import {Component, EventEmitter, Input, Output} from '@angular/core';
import { CommonModule } from '@angular/common';
import {ChipComponent, ChipItem} from "../chip/chip.component";
import {LoadingModule} from "../../../../components/common/loading/loading.module";
import {TablerIconsModule} from "angular-tabler-icons";

@Component({
  selector: 'app-chips',
  standalone: true,
  imports: [CommonModule, ChipComponent, LoadingModule, TablerIconsModule],
  templateUrl: './chips.component.html',
  styles: [
  ]
})
export class ChipsComponent<V> {

  @Input() items: ChipItem<V>[] = [];
  @Input() loading = false;
  @Input() forceOneSelection = false;
  @Input() onlyOneSelection = false;
  @Input() onlyShowSelected = false;
  @Input() disabled = false;

  @Output() selectedChangedEvent: EventEmitter<ChipItem<V>> = new EventEmitter();
  @Output() focussedEvent: EventEmitter<void> = new EventEmitter();

  onlyShowSelectedDisplayOthers = false;

  selectedChanged(event: ChipItem<V>) {
    if (event?.selected) {
      this.onlyShowSelectedDisplayOthers = false;
    }
    if (event?.selected && this.onlyOneSelection) {
      this.items
          .filter(value => value.selected)
          .filter(value => value.value !== event.value)
          .forEach(value => {
            value.selected = false;
            this.selectedChangedEvent.emit(value);
          })
    }
    this.selectedChangedEvent.emit(event);
  }
}
